import { CacheTypenames, IDialog, IDialogService } from '@workbench-stack/core';
import { inject, injectable } from 'inversify';
import { ClientTypes as CommonTypes } from '@common-stack/client-core';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { DialogDocument } from '@workbench-stack/components/lib/editors';

@injectable()
export class DialogService implements IDialogService {

    constructor(
        @inject(CommonTypes.ApolloClient)
        protected client: ApolloClient<any>,
        @inject(CommonTypes.InMemoryCache)
        protected cache: InMemoryCache,
    ) {
    }

    public show(dialog: IDialog) {
        const dialog_input = {
            dialog: {
                ...dialog,
                detail: dialog.detail && dialog.detail.map((item) => ({
                    ...item,
                    inputType: {
                        ...item.inputType,
                        __typename: 'InputTypeDetail',
                    },
                    __typename: CacheTypenames.Detail,
                })),
                primaryButton: {
                    ...dialog.primaryButton,
                    run: dialog.primaryButton.run && {
                        ...dialog.primaryButton.run,
                        __typename: CacheTypenames.ActionRun,
                    },
                    __typename: 'PrimaryButtonAction',
                },
                __typename: CacheTypenames.Dialog,
            },
        };

        this.client.writeQuery({
            query: DialogDocument,
            data: dialog_input,
        });

        return true;
    }

    public closeDialog() {
        const dialog_input = {
            dialog: {
                dialogType: null,
                detail: null,
                primaryButton: null,
                secondaryButton: null,
                checkbox: null,
                __typename: CacheTypenames.Dialog,
            },
        };

        this.client.writeQuery({
            query: DialogDocument,
            data: dialog_input,
        });

        return true;
    }
}
